<div>
  <div class="col-sm-12 header">
    <h4 *ngIf="data.tab != 'Received'">Reassign Lead</h4>
    <h4 *ngIf="data.tab == 'Received'">Assign Lead</h4>
  </div>
  <div class="form-group mb-0" [formGroup]="reassignForm">
    <label>Select CRM*</label>
    <!-- <mat-form-field class="block-input">
      <mat-select placeholder="ZM*" formControlName="userid" (selectionChange)="onUserSelect($event.value)">
        <mat-option *ngFor="let zm of zmList" [value]="zm.userid">
          {{ zm.userid }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->

    <!-- upgrade-commit -->

    <ng-select
      [items]="zmList"
      (change)="onUserSelect($event)"
      bindLabel="userid"
      bindValue="userid"
      dropdownPosition="bottom"
      [searchFn]="customSearchFn"
      formControlName="userid"
      placeholder="Search Pin Code...."
      [hideSelected]="true"
      [searchable]="true"
      #selectOwner
      required
    >
      <ng-template ng-option-tmp let-item="item">
        <div title="{{ item.userid }}">{{ item.userid }}</div>
      </ng-template>
    </ng-select>

    <!-- upgrade-commit -->

    <!-- <ng-select [searchable]="true" dropdownPosition="bottom" formControlName="userid" (change)="onUserSelect($event)"
      [hideSelected]='true' required>
      <ng-option *ngFor="let user of zmList" [value]="user.userid">{{user.userid}}</ng-option>
    </ng-select> -->
  </div>
  <div class="wrapper">
    <button type="button" class="cancel-action" (click)="closeDialog()">
      Cancel
    </button>
    <button
      type="button"
      class="create-action button-ml"
      [disabled]="!reassignForm.valid"
      (click)="ReassignLead()"
    >
      Confirm
    </button>
  </div>
</div>
